exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-original[data-v-01089261]{text-decoration:line-through}@media (max-width: 767px){.price[data-v-01089261]{color:#CFCFCF}}\n", ""]);

// exports
